import React, { useState } from 'react';
import { Instagram, Linkedin, Mail } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const socialLinks = [
  { name: 'Instagram', icon: Instagram, url: 'https://instagram.com/zaramiller_author', handle: '@zaramiller_author' },
  { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/in/zara-miller-author/', handle: 'Zara Miller' },
  { name: 'Email', icon: Mail, url: 'mailto:tirdovas@gmail.com', handle: 'tirdovas@gmail.com' },
];

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, { email });
      setStatus(response.data.message);
      setEmail('');
    } catch (error) {
      setStatus('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mb-8">
      <p className="text-sm text-pink-blush mb-4">Subscribe to my newsletter for updates on new writing and projects</p>
      <form onSubmit={handleSubscribe} className="flex gap-2" data-testid="newsletter-form">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          required
          className="flex-1 px-4 py-2 rounded-full bg-white/10 border-2 border-pink-blush text-white placeholder-pink-blush/70 focus:outline-none focus:ring-2 focus:ring-pink-rose"
          data-testid="newsletter-email-input"
        />
        <button
          type="submit"
          disabled={loading}
          className="px-6 py-2 rounded-full bg-white text-pink-mauve hover:bg-pink-soft transition-colors font-medium disabled:opacity-50"
          data-testid="newsletter-submit-btn"
        >
          {loading ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
      {status && <p className="text-sm text-pink-blush mt-2" data-testid="newsletter-status">{status}</p>}
    </div>
  );
};

const SocialLinks = () => (
  <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-12">
    {socialLinks.map((link) => {
      const Icon = link.icon;
      return (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 text-pink-blush hover:text-white transition-colors group"
          data-testid={`footer-link-${link.name.toLowerCase()}`}
        >
          <div className="p-3 rounded-full bg-white/10 group-hover:bg-white/20 transition-colors">
            <Icon className="w-5 h-5" />
          </div>
          <span className="text-sm font-medium">{link.handle}</span>
        </a>
      );
    })}
  </div>
);

const Footer = () => (
  <footer id="contact" className="py-16 md:py-24 bg-gradient-to-b from-pink-mauve to-brown-deep text-white px-6 md:px-12 lg:px-24">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-serif font-semibold mb-4" data-testid="footer-title">
          Let's Connect
        </h2>
        <p className="text-lg text-pink-soft max-w-2xl mx-auto mb-8" data-testid="footer-description">
          For collaborations, media inquiries, or to discuss projects, reach out through any of the platforms below.
        </p>
        <NewsletterForm />
      </div>
      <SocialLinks />
      <div className="border-t border-white/20 pt-8 text-center">
        <p className="text-sm text-pink-blush">© {new Date().getFullYear()} Zara Miller. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
